<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <div class="select-city">
    <img src="/images/redesignedForm/map.svg" alt="map" />
    <select v-model="cityId">
      <option
        v-for="city in form.allCities"
        :key="city.id"
        :value="city.id"
        :selected="city.id == selectedCity.id"
      >
        <span>{{ city.name }}</span>
      </option>
    </select>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import headerCityChanger from '@mixins/headerCityHandler'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import dotTemplateMixin from '@apps/order-form/src/mixins/dotTemplateMixin'
import { ADDRESS_BOOK_STORE } from '@constants/store'

export default {
  name: 'CitySelect',

  computed: {
    ...mapState(GENERAL_STORE, ['form']),
    ...mapGetters(GENERAL_STORE, ['selectedCity']),

    cityId: {
      get() {
        return this.selectedCity.id
      },
      set(value) {
        this.changeCity(value)
      },
    },
  },

  watch: {
    cityId() {
      this.cityChangeHandler()
    },
  },

  methods: {
    ...mapActions(GENERAL_STORE, ['changeCity', 'calculatePrice']),

    async cityChangeHandler() {
      // Проверяем авторизацию и устанавливаем шаблон точки забора
      if (this.$store.state?.userData) {
        await this.$store.dispatch(`${ADDRESS_BOOK_STORE}/deleteAddressesFromDraft`)
        await this.setDotsData()
      }

      this.calculatePrice()
    },
  },
  mixins: [headerCityChanger, dotTemplateMixin],
}
</script>

<style scoped lang="scss">
.select-city {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 7px;
  padding: 5px 5px 5px 0;

  border-radius: 5px;

  transition: background-color 0.4s;

  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  select {
    width: 100%;
    height: 20px;

    font-size: inherit;
    color: #000;

    background: transparent url('/images/redesignedForm/down-arrow-black.svg') no-repeat;
    background-position-x: calc(100% - 6px);
    background-position-y: 51%;
    background-size: 8px;
    border: none;
    outline: none;

    transition: background-color 0.4s;

    appearance: none;
  }

  &:hover {
    cursor: pointer;

    background-color: #d1d7db;
  }
}
</style>
